// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { Models } from "@hex-insights/app-modules";
import { DistributiveOmit } from "@hex-insights/core";
import { StudentAcademicTermEnrollment, StudentAcademicTermEnrollmentNameFragment } from "../../../Utilities";
import { StudentAcademicTermEnrollmentFormat } from "../../Format";

type ModelForLink = Pick<StudentAcademicTermEnrollment, "id"> & StudentAcademicTermEnrollmentNameFragment;

export type StudentAcademicTermEnrollmentLinkProps = DistributiveOmit<
	Models.LinkProps<ModelForLink>,
	"pageInfoKey" | "format"
>;

/**
 * Link to the given StudentAcademicTermEnrollment instance.
 */
export function StudentAcademicTermEnrollmentLink(props: StudentAcademicTermEnrollmentLinkProps) {
	return (
		<Models.Link<ModelForLink>
			pageInfoKey="StudentAcademicTermEnrollment"
			format={StudentAcademicTermEnrollmentFormat.name}
			{...props}
		/>
	);
}
